import React from "react";
import Col from "@visa/vds/col";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";

const MCSHeader = (props) => {
  return (
    <Row>
      <Col className="vss-header">
        <Typography tag="h1" variant="headline">{props.header}</Typography>
      </Col>
    </Row>
  );
};
export default MCSHeader;
